module.exports = __webpack_public_path__ + "static/media/Oppfatte.3645281e.m4a";